import { useContext, useState } from "react";
import { GraphContext } from "./data";
import { CosmoComponentSimple } from "./cosmo-component-simple";
import { CosmographProvider } from "@cosmograph/react";
import { LinkType, NodeType } from "./model";
import React from "react";

export const SearchPanel = (props: {
  nodes: NodeType[];
  links: LinkType[];
}) => {
  const [search, setSearch] = useState<boolean>(false);

  const [nodes, setNodes] = React.useState<NodeType[]>([]);
  const [links, setLinks] = React.useState<LinkType[]>([]);

  const filterNodes = (value: string) => {
    // console.log("nodes", props.nodes, "links", props.links);
    const newNodes = props.nodes.filter((d: any) => {
      return (
        d["associated_gene"].toLowerCase().indexOf(value) >= 0 ||
        d["protein_rename"].toLowerCase().indexOf(value) >= 0
      );
    });
    const newIds = newNodes.map((d) => d.id);
    const newLinks = props.links.filter((link) => {
      return newIds.includes(link.source) || newIds.includes(link.target);
    });
    return { nodes: newNodes, links: newLinks };
  };
  const onClick = () => {
    const text = document.getElementById("search_text") as HTMLInputElement;
    const value = text.value.trim().toLowerCase();
    if (!value) {
      alert("Please input the text to search.");
      return;
    }

    const newData = filterNodes(value);
    if (newData.nodes.length === 0) {
      alert("No data found.");
      return;
    }

    setSearch(true);
    setNodes(newData.nodes);
    setLinks(newData.links);
  };

  const onClose = () => {
    setSearch(false);
  };
  return (
    <div className="search-panel">
      <input type="text" placeholder="Search Protein Name" id="search_text" />
      <button onClick={onClick}>Search</button>
      {search && (
        <div className="search-panel-on">
          <div className="close-link" onClick={onClose}>
            X
          </div>
          <CosmographProvider nodes={nodes} links={links}>
            <CosmoComponentSimple />
          </CosmographProvider>
        </div>
      )}
    </div>
  );
};
